import { FLOWERAI_CLOUD_ML_MODEL } from '../constants/urls'

export const LOAD_TF_MODEL = 'LOAD_TF_MODEL'
export function loadTFModel() {
    return {
        type: LOAD_TF_MODEL,
        payload: window.tf.loadModel(FLOWERAI_CLOUD_ML_MODEL),
        meta: {
            analytics: {
                eventType: 'interaction',
                eventPayload: {
                    interaction_value: 'undefined',
                    interaction_category: 'Plant-Classifier',
                    interaction_action: 'load-model',
                    interaction_label: 'load model',
                },
            },
        },
    }
}

export const SET_CLASSIFY_IMAGE = 'SET_CLASSIFY_IMAGE'
export function setClassifyImage(image, gardenKnowledge = 'NOT_SPECIFIED') {
    return {
        type: SET_CLASSIFY_IMAGE,
        payload: image,
        meta: {
            analytics: {
                eventType: 'interaction',
                eventPayload: {
                    interaction_value: 'undefined',
                    interaction_category: 'Plant-Classifier',
                    interaction_action: 'set-image',
                    interaction_label: `Knowledge: ${gardenKnowledge}`,
                },
            },
        },
    }
}

export const RESET_CLASSIFY_IMAGE = 'RESET_CLASSIFY_IMAGE'
export function resetClassifyImage() {
    return {
        type: RESET_CLASSIFY_IMAGE,
        payload: null,
    }
}

export const CLASSIFY_PLANT = 'CLASSIFY_PLANT'
export function classifyPlant(model, image, gardenKnowledge = 'NOT_SPECIFIED') {
    const img = new Image(299, 299)
    img.src = image

    let tfImage = window.tf.fromPixels(img, 3)
    tfImage = tfImage.reshape([1, 299, 299, 3])
    tfImage = window.tf.cast(tfImage, 'float32')

    const tensorDiv = window.tf.scalar(255.0)
    const tensorSub = window.tf.scalar(0.5)
    const tensorMul = window.tf.scalar(2.0)
    tfImage = window.tf.div(tfImage, tensorDiv)
    tfImage = window.tf.sub(tfImage, tensorSub)
    tfImage = window.tf.mul(tfImage, tensorMul)

    const prediction = model.predict(tfImage, { batchSize: 1 })

    // TODO: add garden knowledge to tracking params
    return {
        type: CLASSIFY_PLANT,
        payload: prediction.data(),
        meta: {
            analytics: {
                eventType: 'interaction',
                eventPayload: {
                    interaction_value: 'undefined',
                    interaction_category: 'Plant-Classifier',
                    interaction_action: 'classify-image',
                    interaction_label: gardenKnowledge,
                },
            },
        },
    }
}



// WEBPACK FOOTER //
// ./src/actions/classifier.js